import { useAuth } from "react-oidc-context";

const AuthRedirect = () => {
  const auth = useAuth();

  if (auth.isLoading || auth.error) {
    return (
      <div className="row">
        <div className="col s12">
          {auth.isLoading && <h4>Loading...</h4>}
          {auth.error && <h4>Encountering error...</h4>}
        </div>
      </div>
    )
  } else if (auth.isAuthenticated) {
    window.history.replaceState({}, document.title, window.location.pathname);
    window.location.href = '/';
  } else {
    window.location.href = '/';
  }
}

export default AuthRedirect;